import {RouteHelper, RouteInfo} from "../../../route/RouteHelper";
import {Helmet} from "react-helmet";
import React, {useState} from "react";
import {css} from "@emotion/css";
import TabContext from "@mui/lab/TabContext";
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import PaymentGatewayBaseInfo from "../paymentGatewayBaseInfo/PaymentGatewayBaseInfo";
import PaymentGatewayToken from "../paymentGatewayToken/PaymentGatewayToken";
import PaymentGatewayStatus from "../paymentGatewayStatus/PaymentGatewayStatus";
import PaymentGatewayMain from "../paymentGatewayMain/PaymentGatewayMain";
import TabBoxContainer from "../../tabBoxContainer/TabBoxContainer";
import {TransactionsList} from "../../../pages/transactions/TransactionsList";
import {useParams} from "react-router-dom";
import {
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoGridOneColumn
} from "@moeindal/base-raiko-panel-components";

export default function PaymentGatewayInformation() {

    const {id: gateWayId} = useParams()

    const [title, setTitle] = useState("")
    const [value, setValue] = useState(PaymentGatewayInfoTabType.BaseInfo.id)

    const handleChangeTabMenu = (event, newValue) => {
        setValue(newValue)
    }


    return (
        <>
            <Helmet>
                <title className="">{RouteHelper.PaymentGatewaysInformation.name}</title>
            </Helmet>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1rem`}>
                    <RaikoBreadcrumb breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(
                            RouteHelper.PaymentGatewaysList.name,
                            "/panel/payment-gateways-list"),
                        raikoBreadCrumbItemGenerator(
                            title,
                            ""),
                    ]}/>
                    <TabContext value={value}>
                        <TabBoxContainer>
                            <TabList onChange={handleChangeTabMenu} id="default-tab-container" variant="scrollable">
                                <Tab
                                    label={PaymentGatewayInfoTabType.BaseInfo.title}
                                    value={PaymentGatewayInfoTabType.BaseInfo.id}/>
                                <Tab
                                    label={PaymentGatewayInfoTabType.Transactions.title}
                                    value={PaymentGatewayInfoTabType.Transactions.id}/>
                            </TabList>
                        </TabBoxContainer>
                        <TabPanel value={PaymentGatewayInfoTabType.BaseInfo.id}>
                            <RaikoGridOneColumn>
                                <PaymentGatewayBaseInfo setTitle={setTitle}/>
                                <PaymentGatewayToken/>
                                <PaymentGatewayStatus/>
                                <PaymentGatewayMain/>
                            </RaikoGridOneColumn>
                        </TabPanel>
                        <TabPanel value={PaymentGatewayInfoTabType.Transactions.id}>
                            <TransactionsList gateWayId={gateWayId}/>
                        </TabPanel>
                    </TabContext>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}
const PaymentGatewayInfoTabType = {
    BaseInfo: {
        id: "base-info",
        title: "اطلاعات پایه"
    },
    Transactions: {
        id: "transactions",
        title: "تراکنشات"
    },
    Token: {
        id: "token",
        title: "توکن"
    },
    Status: {
        id: "status",
        title: "وضعیت"
    },
    Main: {
        id: "main",
        title: "اصلی"
    }
}